module.exports = __webpack_public_path__ + "static/media/card_bg_7.73736c34.png";